import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrencyString } from 'lib/useCurrencyString';
import { PayGiftCardApply } from './PayGiftCardApply';
import { EGAEventName, useGAHelpers } from 'lib/useGAHelpers';

interface PayGiftCardOverpaymentProps {
    giftCardNumber?: string;
    onCancel: () => void;
    onAccept: () => void;
    giftcardBalance?: number;
    balanceToPay?: number;
}

export const PayGiftCardOverpayment: React.FC<PayGiftCardOverpaymentProps> = ({
    giftCardNumber,
    onCancel,
    onAccept,
    giftcardBalance,
    balanceToPay
}) => {
    const { t } = useTranslation();
    const getCurrencyString = useCurrencyString();
    const { logUserEvent } = useGAHelpers();
    const localisationStrings = React.useMemo(
        () => ({
            title: t('CHECKOUT_GIFTCARD_PARTIAL_REDEMPTION_WARNING_TITLE'),
            body: t('CHECKOUT_GIFTCARD_PARTIAL_REDEMPTION_WARNING_BODY', {
                giftcardBalance: getCurrencyString(giftcardBalance ?? 0),
                balanceToPay: getCurrencyString(balanceToPay ?? 0)
            }),
            primary: t('CHECKOUT_GIFTCARD_PARTIAL_REDEMPTION_WARNING_PROCEED'),
            secondary: t('CHECKOUT_GIFTCARD_PARTIAL_REDEMPTION_WARNING_CANCEL')
        }),
        [balanceToPay, getCurrencyString, giftcardBalance, t]
    );
    const handlePrimaryClick = React.useCallback(() => {
        onAccept();
        logUserEvent(EGAEventName.GiftcardOverpaymentAccepted);
    }, [logUserEvent, onAccept]);
    const handleSecondaryClick = React.useCallback(() => {
        onCancel();
        logUserEvent(EGAEventName.GiftcardOverpaymentDeclined);
    }, [logUserEvent, onCancel]);
    return (
        <PayGiftCardApply
            localisation={localisationStrings}
            giftCardNumber={giftCardNumber}
            onPrimaryClick={handlePrimaryClick}
            onSecondaryClick={handleSecondaryClick}
            noIcon
            noGiftcardNumber
        />
    );
};
